module.exports = __webpack_public_path__ + "fonts/iconfont.1ed0c22c.eot";